import { render, staticRenderFns } from "./ModeDePaiement.vue?vue&type=template&id=01818af4"
import script from "./ModeDePaiement.vue?vue&type=script&lang=js"
export * from "./ModeDePaiement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports